import React from "react";
import "./ChatStyles.css";

const NoSelectedText = () => {
  return (
    <div
      className="col-sm-12 col-md-6 col-lg-6"
      style={{
        borderleft: "1px solid lightgray",
        position: "relative",
      }}
    >
      <div className="container-fluid no-selected-text-container">
        <small className="muted-text" style={{ userSelect: "none" }}>
          Your conversations appear here,
          <br />
          select a chat to get started!
        </small>
      </div>
    </div>
  );
};

export default NoSelectedText;
